module.exports = __webpack_public_path__ + "img/cover.37606e91.jpg";